const challengesData = [
  { value: "rememberingMedications", label: "Remembering my medications" },
  { value: "handleStress", label: "Knowing how to handle stress" },
  { value: "eatingHealthy", label: "Eating healthy" },
  { value: "socialize", label: "Socialize" }
];

export default challengesData;
